// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 2px solid #22225A;
    background-color: #F8F8F8;
    position: sticky;
    top: 0;
    z-index: 1;
    margin-top: 15px;
}

.tab-container {
    display: flex;
    gap: 20px;
}

.tab {
    font-size: 17px;
    font-weight: bold;
    color: #22225A;
    background: none;
    border: none;
    cursor: pointer;
    padding: 12px 20px;
    transition: color 0.3s ease, border-bottom 0.3s ease;
}

.tab:hover {
    color: #1A1A4B;
}

.tab.active {
    position: relative;
}

.tab.active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    background-color: #22225A;
    transition: width 0.3s ease-in-out;
}

.tab:hover::after {
    width: 100%;
}

.tab-container-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-right: 15px;
}

.upload-client-form-tab {
    font-size: 17px;
    font-weight: bold;
    color: #22225A;
    background: none;
    border: none;
    cursor: pointer;
    padding: 12px 20px;
    transition: color 0.3s ease, border-bottom 0.3s ease;
}

.logo-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.logo {
    width: 101px;
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/TobBarTabs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".tabs {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    border-bottom: 2px solid #22225A;\n    background-color: #F8F8F8;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    margin-top: 15px;\n}\n\n.tab-container {\n    display: flex;\n    gap: 20px;\n}\n\n.tab {\n    font-size: 17px;\n    font-weight: bold;\n    color: #22225A;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 12px 20px;\n    transition: color 0.3s ease, border-bottom 0.3s ease;\n}\n\n.tab:hover {\n    color: #1A1A4B;\n}\n\n.tab.active {\n    position: relative;\n}\n\n.tab.active::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #22225A;\n    transition: width 0.3s ease-in-out;\n}\n\n.tab:hover::after {\n    width: 100%;\n}\n\n.tab-container-right {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    margin-right: 15px;\n}\n\n.upload-client-form-tab {\n    font-size: 17px;\n    font-weight: bold;\n    color: #22225A;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 12px 20px;\n    transition: color 0.3s ease, border-bottom 0.3s ease;\n}\n\n.logo-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n}\n\n.logo {\n    width: 101px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
